import type { StateCreator } from "zustand";

import type { ZOpportunityViewsState } from "../types/zustand";

export const opportunityViewsSlice: StateCreator<ZOpportunityViewsState> = (
  set,
  get,
) => ({
  opportunityViews: [],

  setOpportunityViews: opportunityViews => set({ opportunityViews }),
  addOpportunityView: view => {
    set(state => ({
      activeOpportunityView: view,
      opportunityViews: [...state.opportunityViews, view],
    }));
  },
  updateOpportunityViewById: (id, view) =>
    set(state => ({
      opportunityViews: state.opportunityViews.map(v =>
        v.view_id === id ? { ...v, ...view } : v,
      ),
    })),
  removeOpportunityViewById: id =>
    set(state => ({
      opportunityViews: state.opportunityViews.filter(v => v.view_id !== id),
    })),

  activeOpportunityView: null,
  setActiveOpportunityView: activeOpportunityView =>
    set({ activeOpportunityView }),

  shouldShowFiltersAndSorts: false,
  setShouldShowFiltersAndSorts: shouldShowFiltersAndSorts =>
    set({ shouldShowFiltersAndSorts }),

  openSettingsDropdownByViewId: null,
  setOpenSettingsDropdownByViewId: openSettingsDropdownByViewId =>
    set({ openSettingsDropdownByViewId }),

  currentAttributeToFilterOrSort: null,
  setCurrentAttributeToFilterOrSort: currentAttributeToFilterOrSort =>
    set({ currentAttributeToFilterOrSort }),

  searchViewText: "",
  setSearchViewText: searchViewText => set({ searchViewText }),
});
